import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { Tooltip, Typography, IconButton } from '@mui/material';
import v2Styles from "../../../v2Styles.module.css";

import styles from "../../JobStyle.module.css";
import { Switch } from 'antd';

const style = {
  borderTop: '1px solid #000 !important',
  borderColor: "#000 !important",
  padding: '0.5rem 1rem',
  marginBottom: '.5rem',
  backgroundColor: 'white',
};

export default function DraggableActivityV2Row({ genId, activity, index, moveRow, afterDrop, change, loading, onDelete, onToggleActive }) {
  const ref = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: `TABLEROW_${genId}`,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      if (dragIndex === hoverIndex) {
        return
      }
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      moveRow(dragIndex, hoverIndex)
      item.index = hoverIndex
    },
  })
  const [{ isDragging }, drag, preview] = useDrag({
    type: `TABLEROW_${genId}`,
    item: () => {
      return { ...activity, index }
    },
    canDrag: !loading,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      if (monitor.didDrop) {
        afterDrop(item);
      }
    }
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref))

  return (
    <tr ref={preview} style={{ ...style, opacity }} data-handler-id={handlerId}>
      <td className="text-center">
        <IconButton ref={ref} style={{ height: "auto", cursor: "grab" }} disabled={loading} className="p-0">
          <svg xmlns="http://www.w3.org/2000/svg" className={styles.DragIcon} style={{ height: "14px", cursor: "grab" }} viewBox="0 0 320 512">
            <path fill="currentColor" d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z" />
          </svg>
        </IconButton>
      </td>
      <td>
        {index + 1}
      </td>
      <td title={activity.activity_name ? activity.activity_name : ""}><Typography noWrap className={v2Styles.TableText} title={activity.activity_name}>{activity.activity_name ? activity.activity_name : ""}</Typography></td>
      <td title={activity.category_name ? activity.category_name : ""}><Typography noWrap className={v2Styles.TableText}>{activity.category_name ? activity.category_name : ""}</Typography></td>
      <td title={activity.method_name ? activity.method_name : ""}><Typography noWrap className={v2Styles.TableText}>{activity.method_name ? activity.method_name : ""}</Typography></td>
      <td title={activity.created_by_name ? activity.created_by_name : ""}><Typography noWrap className={v2Styles.TableText}>{activity.created_by_name ? activity.created_by_name : ""}</Typography></td>
      <td title={activity.modified_by_name ? activity.modified_by_name : ""}><Typography noWrap className={v2Styles.TableText}>{activity.modified_by_name ? activity.modified_by_name : ""}</Typography></td>
      <td title={activity.approver_name ? activity.approver_name : ""}><Typography noWrap className={v2Styles.TableText}>{activity.approver_name ? activity.approver_name : ""}</Typography></td>
      <td title={activity.edited ? "Modified" : "Not Modified"}>
        {activity.edited ? (
          <div className={`${v2Styles.StatusBox} ${v2Styles.InActiveStatus}`}>
            <Typography className={`${styles.TableText} text-center`} noWrap align="center" style={{ lineHeight: "1" }}>
              Modified
            </Typography>
          </div>
        ) : (
          <div className={`${v2Styles.StatusBox}`} style={{ backgroundColor: "#eee" }}>
            <Typography className={`${styles.TableText} text-center`} noWrap align="center" style={{ color: "#999", lineHeight: "1" }}>
              Not Modified
            </Typography>
          </div>
        )}
      </td>
      <td className="text-center">
        <div className='d-flex align-items-center' style={{ gap: "15px" }}>
          <div style={{ width: "60px" }}>
            {activity.toggled_active === 1 ? (
              <Typography className={`${v2Styles.TableText}`} noWrap>
                Active
              </Typography>
            ) : (
              <Typography className={`${v2Styles.TableText}`} noWrap>
                Inactive
              </Typography>
            )}
          </div>
          <Switch
            title="Active / Inactive Activity"
            onChange={() => onToggleActive()}
            className="cs-switch-v2"
            size="small"
            defaultChecked={activity.toggled_active === 1 ? true : false} />
          <Tooltip title="Edit Activity">
            <span>
              <IconButton disabled={loading} className="p-0" style={{ height: "auto" }} onClick={() => { }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={v2Styles.EditIcon}>
                  <path fill="currentColor" d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z" />
                </svg>
              </IconButton>
            </span>
          </Tooltip>
        </div>
      </td>
    </tr>
  )
}
